// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Application Version
 * Update this when releasing new versions
 */
export const APP_VERSION = '1.0.0';
export const APP_NAME = 'Starship Console';
